import Entity from '../entity'
import Address from '../customers/address';

export default class Supplier extends Entity<number>{
    address_id: number;
    document_type_id: number;
    code: string;
    document: string;
    name: string;
    email: string;
    contact: string;
    active: boolean;

    address: Address;
    full_name: string;
}


